import React from "react";
import about1 from '../assets/img/about.jpg'
import about2 from '../assets/img/about-2.jpg'
const AboutUs = () => {
  return (
    <React.Fragment>
      <section id="about" class="about section">


        <div class="container section-title" data-aos="fade-up">
          <h2>About Us<br /></h2>
          <p><span>Learn More</span> <span class="description-title">About Us</span></p>
        </div>

        <div class="container">

          <div class="row gy-4">
            <div class="col-lg-7" data-aos="fade-up" data-aos-delay="100">
              <img src={about1} class="img-fluid mb-4" alt="" />
              <div class="book-a-table">
                <h3>Book a Table</h3>
                <p>+91 97835 54885</p>
              </div>
            </div>
            <div class="col-lg-5" data-aos="fade-up" data-aos-delay="250">
              <div class="content ps-0 ps-lg-5">
                <p class="fst-italic">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                  magna aliqua.
                </p>
                <ul>
                  <li><i class="bi bi-check-circle-fill"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></li>
                  <li><i class="bi bi-check-circle-fill"></i> <span>Duis aute irure dolor in reprehenderit in voluptate velit.</span></li>
                  <li><i class="bi bi-check-circle-fill"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</span></li>
                </ul>
                <p>
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                  velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident
                </p>

                <div class="position-relative mt-4">
                  <img src={about2} class="img-fluid mb-4" alt="" />
                  <a href="#" class="glightbox pulsating-play-btn"></a>
                </div>
              </div>
            </div>
          </div>

        </div>

      </section>
    </React.Fragment>

  )
}
export default AboutUs